/**
 * Sticky Navigatio
 */

// Utilities
import debug from "debug";

import plugin from '../../lib/plugin';
const MODULE_NAME = 'core/modules/sticky-navigation';
const log = debug(MODULE_NAME);


class StickyNavigationPlugin {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$viewportElement = $(this.options.viewportElement);
        this.executeFunction;
        this.timeToExecute = 200;

        log('StickyNavigationPlugin', element);

        this.watch();
    }

    onScroll () {
        clearTimeout(this.executeFunction);
        var plug = this;
        this.executeFunction = setTimeout(function(){
            if (plug.$viewportElement.length > 0) {
                var viewportElementVisible = true;
                var offsetTop = $(window).scrollTop();
                var viewportElementOffsetTop = plug.$viewportElement.offset().top;
                plug.$element.removeClass('active');
                if (!plug.isElementInViewport() && offsetTop > viewportElementOffsetTop) {
                    viewportElementVisible = false;
                }

                if (!viewportElementVisible) {
                    plug.$element.addClass('active');
                }
            }
            log('scroll', plug.$element);
        }, this.timeToExecute);
    }

    isElementInViewport () {
        var el = this.$viewportElement;

        //special bonus for those using jQuery
        el = el[0];
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
    }

    watch () {
        $(window).on('scroll', this.onScroll.bind(this));
    }

    unwatch () {
        $(window).off('scroll', this.onScroll.bind(this));
        log('unbound', this.$element);
    }

}

StickyNavigationPlugin.DEFAULTS = {
    viewportElement : '.product-detail__quote .product-quote-form'
};

plugin('stickyNavigation', StickyNavigationPlugin);

// Export
export function exec () {
    $(document).ready( () => {
        log('binding');
        $(".sticky-navigation").stickyNavigation();
        log('bound');
    });
}






// WEBPACK FOOTER //
// ./client/src/core/modules/sticky-navigation/index.js